module.exports = __webpack_public_path__ + "static/media/Figma.b2efe158.svg";